import React from 'react';
import { BlobProvider, PDFDownloadLink } from '@react-pdf/renderer';
import { Button, Modal } from 'react-bootstrap';
import dayjs from 'dayjs';
import { CallOutCalendarPdf } from './CallOutCalendarPdf';
import { PdfMultiMonthModel } from '../types';

export const PrintCalendarPdfModal = ({
  show,
  onHide,
  pdfModel
}: {
  show: boolean;
  onHide: () => void;
  pdfModel: PdfMultiMonthModel;
}) => {
  const monthCount = pdfModel.months.length;
  const fileName = `callout-calendar-all-months-${dayjs().format(
    'YYYY-MM-DD'
  )}.pdf`;

  return (
    <Modal show={show} onHide={onHide} centered size="xl">
      <Modal.Header closeButton>
        <Modal.Title>Calendar PDF</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <p className="text-600 mb-0">
            Generating PDF with {monthCount} month{monthCount !== 1 ? 's' : ''}{' '}
            that have booked assignments.
          </p>
        </div>

        <div className="mt-3" style={{ height: '70vh' }}>
          <BlobProvider document={<CallOutCalendarPdf model={pdfModel} />}>
            {({ url, loading, error }) => {
              if (loading) {
                return (
                  <div className="text-center text-600 py-5">
                    Generating PDF…
                  </div>
                );
              }
              if (error) {
                return (
                  <div className="text-danger py-3">
                    Failed to generate PDF.
                  </div>
                );
              }
              if (!url) return null;
              return (
                <iframe
                  title="Call-Out Calendar PDF Preview"
                  src={url}
                  style={{
                    width: '100%',
                    height: '100%',
                    border: '1px solid rgba(0,0,0,0.12)',
                    borderRadius: 8
                  }}
                />
              );
            }}
          </BlobProvider>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
        <PDFDownloadLink
          document={<CallOutCalendarPdf model={pdfModel} />}
          fileName={fileName}
          style={{ textDecoration: 'none' }}
        >
          {({ loading }) => (
            <Button variant="primary" disabled={loading}>
              {loading ? 'Preparing…' : 'Download PDF'}
            </Button>
          )}
        </PDFDownloadLink>
      </Modal.Footer>
    </Modal>
  );
};
